<template>
    <list-group-item :action="clickAction" color="primary">
        <i class="fas fa-user-cog"></i> <strong>Complete Payout &amp; Tax Information</strong>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';

    import { UseUIStore } from '@/store/UI.js';
    import { UseAuthStore } from '@/store/Auth.js'

    export default {
        components: {
            ...UIComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
                authStore: UseAuthStore(),
            };
        },


        emits: ['click'],

        methods: {
            clickAction() {
                this.$emit('click');
                let homepage = this.uiStore.homePageLink;
                // redirect the user to either the owners or partners portal
                if (homepage == '/') {

                    if (this.authStore.hasRole('owner')) {
                        homepage = '/owners';
                    }
                    else if (
                        (this.authStore.hasRole('broker')) ||
                        (this.authStore.hasRole('travel_agent')) ||
                        (this.authStore.hasRole('affiliate')) ||
                        (this.authStore.hasRole('referral')) ||
                        (this.authStore.hasRole('partner_referrer'))
                    ) {
                        homepage = '/partners';
                    }
                    else {
                        homepage = '/travelers';
                    }
                }
                this.$router.push(homepage+'/accounting/initial-w9');
            },
        },
    }
</script>